var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2649.434,
    height: 2048.577,
    viewBox: "0 0 2649.434 2048.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_51958",
    "data-name": "Raggruppa 51958",
    transform: "translate(626.493 -1417.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64838",
    "data-name": "Tracciato 64838",
    d: "M1585.587,3466-624.587,2283.413S1190.5,2238.5,665.5,1760.5",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64839",
    "data-name": "Tracciato 64839",
    d: "M653.351,1740.353c446.02,406.091-931.2,581.917-1197.95,592.47-28.766,1.138-44.44.541-43.469-1.167,6.1-10.737,1041.428,491.455,1070.355,495.768,33.529,5,1129,626.193,1129,626.193",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64840",
    "data-name": "Tracciato 64840",
    d: "M641.2,1720.206c418.144,380.71-903.494,653.769-1153.577,663.662-26.968,1.067-41.118-.552-39.175-3.969,12.207-21.473,1008.557,408.09,1066.412,416.717,67.058,10,1122.126,644.619,1122.126,644.619",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64841",
    "data-name": "Tracciato 64841",
    d: "M629.054,1700.059c390.268,355.329-875.791,725.62-1109.2,734.854-25.17,1-37.8-1.646-34.883-6.77,18.312-32.21,975.688,324.725,1062.469,337.666,100.589,15,1115.251,663.044,1115.251,663.044",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64842",
    "data-name": "Tracciato 64842",
    d: "M616.905,1679.912C979.3,2009.861-231.184,2477.384-447.922,2485.958c-23.373.925-34.474-2.74-30.59-9.572C-454.1,2433.439,464.3,2717.746,580.014,2735,714.132,2755,1688.39,3416.47,1688.39,3416.47",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64843",
    "data-name": "Tracciato 64843",
    d: "M604.757,1659.765C939.272,1964.333-215.63,2529.088-415.7,2537c-21.574.853-31.151-3.833-26.3-12.374,30.519-53.683,909.947,158,1054.583,179.564,167.647,25,1101.5,699.895,1101.5,699.895",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64844",
    "data-name": "Tracciato 64844",
    d: "M592.608,1639.618c306.639,279.187-792.685,941.175-976.079,948.43-19.776.782-27.83-4.927-22-15.176,36.623-64.419,877.076,74.631,1050.64,100.513,201.176,30,1094.626,718.321,1094.626,718.321",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64845",
    "data-name": "Tracciato 64845",
    d: "M580.459,1619.471c278.763,253.806-764.982,1013.026-931.7,1019.622-17.979.711-24.508-6.021-17.71-17.977,42.726-75.157,844.206-8.734,1046.7,21.462,234.706,35,1087.75,736.745,1087.75,736.745",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64846",
    "data-name": "Tracciato 64846",
    d: "M568.311,1599.324C819.2,1827.75-168.97,2684.2-319.019,2690.138c-16.181.64-21.186-7.114-13.417-20.779,48.83-85.893,811.336-92.1,1042.754-57.589,268.235,40,1080.875,755.171,1080.875,755.171",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64847",
    "data-name": "Tracciato 64847",
    d: "M556.162,1579.177c223.01,203.045-709.578,1156.729-842.956,1162.006-14.383.569-17.863-8.208-9.124-23.581,54.934-96.63,778.466-175.463,1038.811-136.64,301.765,45,1074,773.6,1074,773.6",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64848",
    "data-name": "Tracciato 64848",
    d: "M544.013,1559.03c195.134,177.664-681.876,1228.581-798.581,1233.2-12.585.5-14.541-9.3-4.831-26.383,61.038-107.366,745.6-258.828,1034.868-215.691,335.294,50,1067.126,792.022,1067.126,792.022",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64849",
    "data-name": "Tracciato 64849",
    d: "M531.864,1538.883c167.258,152.284-654.173,1300.433-754.206,1304.39-10.788.427-11.22-10.4-.538-29.185,67.142-118.1,712.725-342.192,1030.925-294.741,368.824,55,1060.25,810.447,1060.25,810.447",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64850",
    "data-name": "Tracciato 64850",
    d: "M519.716,1518.736C659.1,1645.639-106.756,2891.02-190.117,2894.318c-8.989.355-7.9-11.489,3.756-31.986,73.245-128.84,679.855-425.558,1026.982-373.793,402.353,60,1053.375,828.873,1053.375,828.873",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64851",
    "data-name": "Tracciato 64851",
    d: "M507.567,1498.589C619.072,1600.111-91.2,2942.725-157.891,2945.363c-7.191.284-4.575-12.582,8.049-34.788C-70.493,2771,497.142,2401.653,873.2,2457.731c435.882,65,1046.5,847.3,1046.5,847.3",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64852",
    "data-name": "Tracciato 64852",
    d: "M495.418,1478.441c83.629,76.142-571.067,1515.988-621.083,1517.967-5.394.213-1.253-13.676,12.342-37.59,85.452-150.312,614.114-592.287,1019.1-531.9,469.411,70,1039.625,865.724,1039.625,865.724",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64853",
    "data-name": "Tracciato 64853",
    d: "M483.27,1458.294C539.022,1509.056-60.1,3046.134-93.44,3047.453c-3.6.142,2.069-14.769,16.636-40.392C14.752,2846.012,504.44,2331.41,938.348,2396.116c502.942,75,1032.75,884.149,1032.75,884.149",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64854",
    "data-name": "Tracciato 64854",
    d: "M471.121,1438.147C499,1463.528-44.542,3097.838-61.214,3098.5c-1.8.071,5.391-15.863,20.928-43.193,97.661-171.786,548.374-759.017,1011.21-690,536.471,80,1025.875,902.574,1025.875,902.574",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64855",
    "data-name": "Tracciato 64855",
    d: "M458.972,1418-28.988,3149.543S433.5,2249.5,1003.5,2334.5s1019,921,1019,921",
    fill: "none",
    stroke: "#60499e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgProducts);
export default __webpack_public_path__ + "static/media/bg-products.6b95eb20c2a6630340544dfb1dc3670f.svg";
export { ForwardRef as ReactComponent };